import React from "react"
import * as LD from "@walmart-web/livingdesign-components"
import "components/UserManagement/components/Forms/Users/index.scss"

const Skeleton: React.FC = () => (
	<div className="skeleton">
		<div className="row">
			<div className="item-skeleton">
				<LD.Skeleton height="1rem" width="10rem" />
				<LD.Skeleton height="3rem" />
			</div>
			<div className="item-skeleton">
				<LD.Skeleton height="1rem" width="10rem" />
				<LD.Skeleton height="3rem" />
			</div>
		</div>
		<div className="row">
			<div className="item-skeleton">
				<LD.Skeleton height="1rem" width="10rem" />
				<LD.Skeleton height="3rem" />
			</div>
			<div className="item-skeleton">
				<LD.Skeleton height="1rem" width="10rem" />
				<LD.Skeleton height="3rem" />
			</div>
		</div>
		<LD.Skeleton height="1rem" width="10rem" />
		{[...Array(7)].map((value, index) => (
			<LD.Skeleton height="1.5rem" width="7.5rem" key={"skeleton" + index} />
		))}
	</div>
)

export default Skeleton
